import { Directive, HostListener, Input } from '@angular/core';
import { AbstractPlayButtonService } from './abstract-play-button.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[osnPlay]',
})
export class PlayButtonDirective {
  @Input() public guid: string;
  @Input() public movieOrSeriesTitle: string | undefined;
  @Input() public isTrailer = false;
  @Input() public fromPlayer = false;

  @HostListener('click') public onClick() {
    this.service.playVideo(this.guid, this.isTrailer, this.movieOrSeriesTitle, this.fromPlayer);
  }

  constructor(private readonly service: AbstractPlayButtonService) {}
}
